export default function formatDate(dateValue: string | Date | undefined | null): string {
  if (!dateValue) return '';
  
  const date = new Date(dateValue);
  
  if (isNaN(date.getTime())) return '';

  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
